var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total"},[_vm._v(_vm._s(_vm.$t('label_dashboard_total'))+": "),_c('div',{staticClass:"total-number"},[_vm._v(" "+_vm._s(_vm.fomat? _vm.formatCompact(_vm.totalOrganizations) : _vm.formatNumber(_vm.totalOrganizations)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }